module.exports = __webpack_public_path__ + "static/media/Login-BG@2x.35edb569.jpg";